import React from "react";

const LoadingBoxes = () => {
  return (
    <div className="boxes">
      {[1, 2, 3, 4].map((_, i) => (
        <div className="box" key={i}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      ))}
    </div>
    

  );
};

export default LoadingBoxes;
